<template>
    <div class="alert-list table-responsive text-center mt-2">
        <table class="table table-striped table-sm mb-0">
            <thead class="bg-hub-primary text-white sticky-top">
                <tr>
                    <th class="text-left" style="width: 30%">Name</th>
                    <th style="width: 20%">Extension</th>
                    <th style="width: 50%">Play</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="alert in filtered_alerts" :key="alert.event_id">
                    <td class="text-left align-middle">{{ alert.name }}</td>
                    <td class="align-middle">
                        <span v-if="alert.extension !== 0">{{ alert.extension }}</span>
                        <span v-else>N/A</span>
                    </td>
                    <td class="align-middle" style="height: 60px">
                        <a class="btn btn-sm w-100 h-100 p-0" @click="executeAlert(alert)">
                            <i class="fa fa-play fa-fw h-100 pt-3" style="font-size: 20px" aria-hidden="true"></i> 
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EVENT_TYPE } from '../../../assets/js/resource-types'

export default {
    computed: {
        ...mapGetters({
            events: 'allEvents',
            scoped_site_id: 'scopedSiteId',
        }),
        filtered_alerts: function () {
            return this.events.filter(event => event.site_id === this.scoped_site_id && event.event_type_id == EVENT_TYPE.Alert)
        }
    },
    created() {
        this.$store.dispatch('setDisabledChangeScopedSite', false)
        this.$store.dispatch('getEvents')
    },
    methods: {
        executeAlert(alert) {
            this.g2dialog.$confirm(`You are about to activate an alert (${alert.name}). Continue?`)
                .then(confirmed => confirmed && this.$store.dispatch('executeAlert', alert.event_id))
        }
    }
}
</script>

<style>
.alert-list {
    max-height: 40vh;
    border: 1px solid #ccc;
}
</style>